import { createSlice } from '@reduxjs/toolkit';

export const chatSelectSlice = createSlice({
  name: 'chatSelect',
  initialState: {
    globalChatSelect: true,
    allChatsHidden: true,
    participantList: {
      status: false,
      isGlobalParticipants: false,
    },
  },
  reducers: {
    selectChat: (state, action) => {
      const { isGlobalChat } = action.payload;
      return {
        ...state,
        globalChatSelect: isGlobalChat,
        participantList: {
          status: false,
          isGlobalParticipants: false,
        },
      };
    },
    setChatsHidden: (state, action) => {
      const { areHidden } = action.payload;
      return {
        ...state,
        allChatsHidden: areHidden,
        participantList: {
          status: false,
          isGlobalParticipants: false,
        },
      };
    },
    updateActiveChatAndHiddenStatus: (state, action) => {
      const { isGlobalChat, areHidden } = action.payload;
      return {
        ...state,
        globalChatSelect: isGlobalChat,
        allChatsHidden: areHidden,
        participantList: {
          status: false,
          isGlobalParticipants: false,
        },
      };
    },
    updateParticipantList: (state, action) => {
      const { status, isGlobalParticipants } = action.payload;
      // const prevStateList = state.participantList.isGlobalParticipants;
      return {
        ...state,
        participantList: {
          status: status,
          isGlobalParticipants: isGlobalParticipants,
        },
      };
    },
  },
});

export const {
  selectChat,
  setChatsHidden,
  updateActiveChatAndHiddenStatus,
  updateParticipantList,
} = chatSelectSlice.actions;

export default chatSelectSlice.reducer;
